export default "__VITE_ASSET__B2r$R66L__"